<template>
<!-- v-if="hideArr.indexOf(workbench.roleTips) < 0" -->
  <div class="workbench" >
    <!--        <div class="lists flex-between" v-if="arr.indexOf(workbench.roleTips) > -1">-->
    <!--            <div class="list">-->
    <!--                <div class="title">{{$lange == 'en' ? 'Service request' : '服务请求'}}</div>-->
    <!--                <div class="context">{{workbench.workOrderCount}}</div>-->
    <!--            </div>-->
    <!--            <div class="list" >-->
    <!--                <div class="title">{{$lange == 'en' ? 'Outward order' : '外派订单'}}</div>-->
    <!--                <div class="context">{{workbench.expatriateOrderCount}}</div>-->
    <!--            </div>-->
    <!--            <div class="list" >-->
    <!--                <div class="title">{{$lange == 'en' ? 'Spare parts order' : '配件订单'}}</div>-->
    <!--                <div class="context">{{workbench.partsOrderCount}}</div>-->
    <!--            </div>-->
    <!--        </div>-->
     <!-- v-if="arr.indexOf(workbench.roleTips) > -1 -->
    <div class="top" >
      {{$lange == 'en' ? 'Service request' : '服务请求'}}
      <span
        style="color: #F56C6C;margin-left: 5px; margin-right: 25px;"
        class="number-text"
      >{{workbench.workOrderCount}}</span>
      {{$lange == 'en' ? 'Field service' : '外派订单'}}
      <span
        style="color: #F56C6C;margin-left: 5px; margin-right: 25px;"
        class="number-text"
      >{{workbench.expatriateOrderCount}}</span>
      {{$lange == 'en' ? 'Spare Parts Order' : '配件订单'}}
      <span
        style="color: #F56C6C;margin-left: 5px; margin-right: 110px;"
        class="number-text"
      >{{workbench.partsOrderCount}}</span>
      <el-input
        v-model="search.customerName"
        :placeholder="$lange == 'en' ? 'customer' : '客户名称'"
        style="display: inline-block;width: 170px;margin-right: 15px;"
        size="mini"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-input
        v-model="search.jobId"
        placeholder="Job"
        style="display: inline-block;width: 170px;margin-right: 15px;"
        size="mini"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-input
        v-model="search.fasId"
        placeholder="Poject No."
        style="display: inline-block;width: 170px;margin-right: 15px;"
        size="mini"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button size="mini" type="primary" @click="goPage">{{$lange == 'en' ? 'New Request' : '创建工单'}}</el-button>
    </div>
    <mapComponent :search-params="search"></mapComponent>
  </div>
</template>

<script>
import mapComponent from "./mapComponent";
export default {
  name: "Workbench",
  props: {
    workbench: {
      type: Object,
    },
  },
  components: {
    mapComponent,
  },
  data() {
    return {
      arr: ["technicalSupport", "accessoriesSpecialist", "projectManager",'afterSalesManager'],
      hideArr: ["staff", "squadLeader", "management"],
      search: {
        customerName: "",
        jobId: "",
        fasId: "",
      },
    };
  },
  methods: {
    goPage() {
      this.$router.push({
        path: "admin/order/create",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.workbench {
  .lists {
    justify-content: flex-start;
    text-align: center;
    padding: 30px;

    .list {
      width: 300px;
      background: #ffffff;
      box-shadow: 0 0 9px 3px rgba(0, 0, 0, 0.1);
      margin-right: 30px;
      .title {
        padding: 10px;
        border-bottom: 1px solid #eeeeee;
        font-size: 24px;
      }
      .context {
        padding: 30px;
        font-size: 22px;
        color: #d92525;
      }
    }
  }
  .top {
    padding: 20px;
    background: #ffffff;
    font-size: 18px;
    .number-text {
      font-weight: bolder;
    }
  }
}
</style>
